/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface MaterialFileDownloadPayload {
    careerId: string;
    fileIndex: string;
}

export interface MaterialFileDownloadResponse {
    fileData: string;
    contentType: string;
    fileName: string;
}

class MaterialFileDownloadService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "materialFileDownload");
    }

    public async materialFileDownload(
        payload: MaterialFileDownloadPayload,
        resolved: (json: MaterialFileDownloadResponse) => void,
        rejected: (error: any) => void
    ) {
        await super.postJSON(
            payload,
            (json: any) => {
                const response = json as MaterialFileDownloadResponse;
                resolved(response);
            },
            rejected
        );
    }
}

export default MaterialFileDownloadService;
